import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { fadeUp } from "./shared";

export function StoriesSection({ stories }) {
  return (
    <section id="stories" className="max-w-6xl mx-auto px-5 py-14">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-turq-600 flex items-center justify-center"><Sparkles className="w-5 h-5 text-white" /></div>
        <div>
          <h2 className="font-head font-black text-2xl">قصص الأثر</h2>
          <p className="text-xs text-mutext">من ميدان مدارس الشرقية إلى المجتمع</p>
        </div>
      </div>
      {stories.length === 0 ? (
        <div className="text-center text-sm text-mutext py-10">قصص الأثر قادمة قريباً بإذن الله</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {stories.map((s) => (
            <motion.div key={s.id} initial="hidden" whileInView="show" viewport={{ once: true }} variants={fadeUp}
              data-testid={`story-card-${s.id.slice(0, 8)}`}
              className="rounded-2xl overflow-hidden border border-brd bg-surface shadow-md shadow-turq-900/5">
              {s.image ? (
                <img src={s.image} alt={s.opportunity_name} className="w-full h-40 object-cover" />
              ) : (
                <div className="w-full h-40 flex items-center justify-center text-white font-head font-bold text-sm px-4 text-center"
                  style={{ background: "linear-gradient(120deg,#0B6E7A,#FF7A59)" }}>
                  {s.opportunity_name}
                </div>
              )}
              <div className="p-3.5">
                <div className="text-xs font-bold text-turq-900 dark:text-turq-300">{s.opportunity_name}</div>
                <div className="text-[10.5px] text-mutext mt-0.5">{s.school_name}</div>
                {s.caption && <p className="text-[11px] text-mutext mt-1.5 leading-relaxed line-clamp-2">{s.caption}</p>}
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </section>
  );
}
